'use client'

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/ui/atoms/accordion/Accordion'
import { Typography } from '@/ui/atoms/typography/Typography'

const faqs = [
  {
    question: 'What is the HypurrFi Card?',
    answer:
      'The HypurrFi Card is a payment card that lets you access spending power by borrowing against your crypto. Instead of selling your holdings, you use them as collateral to access everyday purchasing power while keeping your assets on-chain.',
  },
  {
    question: 'How does spending work?',
    answer:
      'When you tap your card, it borrows against your collateral in real time. There are no off-ramps, no top-ups, and no pre-loading required. You spend, the card borrows, and you repay on your own terms.',
  },
  {
    question: 'Do I need to top up or pre-load the card?',
    answer:
      'No. Unlike traditional crypto cards that require you to convert and load funds first, the HypurrFi Card borrows directly against your collateral at the moment of purchase. Your crypto stays on-chain.',
  },
  {
    question: 'What crypto can I use as collateral?',
    answer:
      'You can use a variety of supported crypto assets as collateral, including ETH, WBTC, USDC, USDT, and other major tokens. The specific assets available depend on the protocols integrated with HypurrFi.',
  },
  {
    question: 'Is there a credit check?',
    answer:
      'No. Your spending capacity is determined by the value of your crypto collateral, not your credit score. Get approved quickly without impacting your credit history.',
  },
  {
    question: 'Where can I use the card?',
    answer:
      'Anywhere Visa is accepted — over 150 million merchants, online and in-store. You can also use it for subscriptions and bill payments.',
  },
  {
    question: 'How do I get started?',
    answer:
      'Connect your wallet and check your eligibility. Access is available in select jurisdictions and is being rolled out based on eligibility criteria including wallet history.',
  },
]

export function CardFAQ() {
  return (
    <section className="py-12 lg:py-20">
      <div className="mx-auto max-w-3xl px-4 lg:px-8 sm:px-6">
        <div className="mb-10 text-center lg:mb-16">
          <Typography variant="h2" className="text-3xl lg:text-4xl" gradient>
            Got Questions?
          </Typography>
          <Typography variant="p" className="mx-auto mt-4 max-w-2xl text-muted-foreground">
            Everything you need to know about the HypurrFi Card
          </Typography>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left text-foreground hover:text-primary">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{faq.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  )
}
